import React from "react";
import { AlertTriangle, Info } from "lucide-react";
import Button from "../button/Button";
import type { ScheduleUnavailableNoticeProps } from "./ScheduleUnavailableNotice.types";

const COPY = {
    empty: {
        title: "Aucune donnée à afficher",
        description: "Aucun quart n'a été retourné pour ce groupe de travail. Vérifiez la période et le groupe sélectionnés, puis réessayez.",
    },
    error: {
        title: "Connexion au solveur impossible",
        description: "Vérifiez que le service est démarré, puis réessayez.",
    },
} as const;

const ScheduleUnavailableNotice: React.FC<ScheduleUnavailableNoticeProps> = ({
                                                                                variant,
                                                                                onRetry,
                                                                                isRetrying = false,
                                                                            }) => {
    const { title, description } = COPY[variant];
    const isError = variant === "error";
    const Icon = isError ? AlertTriangle : Info;

    return (
        <div className="max-w-md rounded-lg border border-border bg-card px-4 py-3">
            <div className="flex items-start gap-3">
                <Icon size={20} className={`mt-0.5 shrink-0 ${isError ? "text-red-600" : "text-muted-foreground"}`}/>
                <div className="flex-1">
                    <p className="font-medium">{title}</p>
                    <p className="text-sm text-muted-foreground">{description}</p>
                    <Button
                        onClick={onRetry}
                        label={isRetrying ? "Nouvel essai…" : "Réessayer"}
                        type={isError ? "danger" : "secondary"}
                        size="sm"
                        rounded
                        disabled={isRetrying}
                        className="mt-3"
                    />
                </div>
            </div>
        </div>
    );
};

export default ScheduleUnavailableNotice;
